module.exports = __webpack_public_path__ + "files/a9d352b7be98d4a984e1600f26aca943.woff2";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/google-fonts/fonts/droidserif-italic-webfont.woff2
// module id = 816
// module chunks = 60